<template>
    <div class="w-100">
        <div  class="btn-function-list">
            <div class="text-right">
                <!--TODO 留言-->
                <el-button type="text" class="message" v-if="messageCount >= 0">
                    <img src="@/assets/images/message.svg">{{messageCount}}
                </el-button>

                <span class="ml-2 pageviews">瀏覽 {{viewCount}}</span>
            </div>

        </div>

        <!--TODO 分享-->
        <el-dialog
                title="分享留言"
                :visible.sync="ShareModal"
                class="md"
                center>
            <div class="share-block">
                <div class="icon">
                    <img src="../assets/images/icon_Line.svg">
                    <span>LINE</span>
                </div>
                <div class="icon">
                    <img src="../assets/images/icon_FB.svg">
                    <span>FacebooK</span>
                </div>
                <div class="icon">
                    <img src="../assets/images/icon_Messenger.svg">
                    <span>Messenger</span>
                </div>
                <div class="icon">
                    <img src="../assets/images/icon_IG.svg">
                    <span>Instagram</span>
                </div>
                <div class="icon">
                    <img src="../assets/images/icon_AirDrop.svg">
                    <span>AirDrop</span>
                </div>
                <div class="icon">
                    <img src="../assets/images/icon_newsletter.svg">
                    <span>訊息</span>
                </div>
                <div class="icon">
                    <img src="../assets/images/icon_email.svg">
                    <span>郵件</span>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="ShareModal = false" round class="w-75">取 消</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
  name: "NewsFunction",
  props: {
    viewCount: Number,
    messageCount: Number,
  },
  data() {
    return {
        ShareModal: false,//分享文章彈框
    }
  },
  created() {

  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<style scoped lang="less">
    /*留言按讚分享常駐*/
    .btn-function-list {
        width: 100%;
        display: flex;
        margin: 0 0 -20px;
        img {
            height: 25px;
            width: inherit;
            margin-right: 5px;
            vertical-align: -50%;
        }
        button {
            color: var(--color-dark);
            margin-right: 8px;
            &:focus {
                outline: none;
            }
        }
        .text-right {
            flex: 1;
            font-size: 14px;
        }
    }
</style>
